<template>
  <div class="badge-container" v-click-outside="closeAgenda">
    <button type="button" class="sendRequestButton" @click="toggleAgenda">
      <img src="@/assets/img/icons/agenda.svg" class="icon" alt="Agenda">
    </button>

    <span class="badge" v-if="sortedEvents.length > 0">
      {{ sortedEvents.length }}
    </span>

    <transition name="fade">
      <div v-if="isAgendaOpen" class="agenda-dropdown-panel">
        <div class="panel-header">
          <span class="panel-title">Agenda</span>
          <button type="button" @click="closeAgenda" class="close-btn">×</button>
        </div>

        <div class="panel-body">
          <div v-for="item in sortedEvents" :key="item.id" class="agenda-item">
            <div class="status-bar" :class="isToday(item.start) ? 'bg-danger' : 'bg-warning'"></div>

            <div class="item-info">
              <p class="title-text">{{ item.title }}</p>
              <p class="subtitle-text">{{ item.owners_association_name }}</p>
            </div>

            <span class="tag-relative" :class="isToday(item.start) ? 'tag-danger' : 'tag-warning'">
              {{ getRelativeText(item.start) }}
            </span>
          </div>

          <div v-if="sortedEvents.length === 0" class="p-4 text-center text-muted">
            No hay eventos próximos
          </div>
        </div>

        <div class="panel-footer">
          <button class="btn-ver-agenda btn btn-primary w-100" @click="goToAgenda">
            VER AGENDA
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AgendaIconDropdown',
  data() {
    return {
      isAgendaOpen: false,
      upcomingEvents: [],
    };
  },
  computed: {
    // Ordenamos de más cercano a hoy hacia adelante
    sortedEvents() {
      return [...this.upcomingEvents].sort((a, b) => new Date(a.start) - new Date(b.start));
    },
  },
  methods: {
    async fetchEvents() {
      try {
        const events = await this.getUpcomingEvents();
        this.upcomingEvents = events;
      } catch (error) {
        console.error('Error al obtener eventos de agenda', error);
      }
    },
    toggleAgenda() {
      this.isAgendaOpen = !this.isAgendaOpen;
      if (this.isAgendaOpen) this.fetchEvents();
    },
    closeAgenda() {
      this.isAgendaOpen = false;
    },
    goToAgenda() {
      this.isAgendaOpen = false;
      this.$router.push('/agenda').catch(() => {});
    },
    isToday(date) {
      return moment(date).isSame(moment(), 'day');
    },
    getRelativeText(date) {
      const eventDate = moment(date).startOf('day');
      const today = moment().startOf('day');
      const diff = eventDate.diff(today, 'days');

      if (diff === 0) return 'Hoy';
      if (diff === 1) return 'Mañana';
      return `En ${diff} días`;
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  created() {
    this.fetchEvents();
  },
};
</script>

<style lang="scss" scoped>
.badge-container {
  position: relative;
  display: inline-block;
}
.badge {
  position: absolute;
  top: -5px; right: -5px;
  background-color: #CE4169;
  color: white;
  border-radius: 50%;
  font-size: 10px;
  font-weight: bold;
  width: 16px; height: 16px;
  display: flex; align-items: center; justify-content: center;
  border: 1px solid white;
  pointer-events: none;
}
.agenda-dropdown-panel {
  position: absolute;
  top: 40px; right: 0;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
  z-index: 10000;
  border: 1px solid #ddd;
  overflow: hidden;
  .panel-header {
    display: flex; justify-content: space-between; align-items: center;
    padding: 12px 15px; border-bottom: 1px solid #eee;
    .panel-title { font-weight: 600; color: #333; font-size: 15px; }
    .close-btn { background: none; border: none; font-size: 22px; color: #bbb; cursor: pointer; }
  }
  .panel-body {
    max-height: 350px; overflow-y: auto;
    .agenda-item {
      display: flex; align-items: center; padding: 12px 15px; border-bottom: 1px solid #f5f5f5;
      position: relative;

      .status-bar {
        position: absolute; left: 0; top: 0; bottom: 0; width: 3px;
      }
      .bg-danger { background-color: #dc3545; }
      .bg-warning { background-color: #ffc107; }

      .item-info {
        flex: 1; padding-left: 12px; text-align: left;
        .title-text { margin: 0; font-size: 14px; font-weight: 600; color: #2c3e50; }
        .subtitle-text { margin: 2px 0 0 0; font-size: 11px; color: #7f8c8d; }
      }

      .tag-relative {
        font-size: 10px; padding: 2px 8px; border-radius: 4px; font-weight: bold; white-space: nowrap;
      }
      .tag-danger {
        background: #fff1f0; color: #dc3545; border: 1px solid #ffa39e;
      }
      .tag-warning {
        background: #fffbe6; color: #d48806; border: 1px solid #ffe58f;
      }
    }
  }
  .panel-footer {
    padding: 12px; background: #f8f9fa;
  }
}
.fade-enter-active, .fade-leave-active { transition: opacity .3s; }
.fade-enter, .fade-leave-to { opacity: 0; }
</style>
